import { LOCALE_ID, Provider } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_NATIVE_DATE_FORMATS } from '@angular/material/core';
import { AdaptadorDataBr } from '@shared/util/data-br.adapter';

/**
 * Datas em pt-BR: `01/08/2026` nos campos de calendário e nos nomes de mês, na aplicação inteira.
 *
 * <p>Sem isto o Angular assume en-US e os campos ficam em `8/1/2026`, destoando de todo o resto
 * da tela — grades, faixa de filtros e relatórios já mostravam dd/mm/aaaa.</p>
 *
 * <p>É um array e não um `provide...()` porque os testes precisam exatamente do mesmo conjunto:
 * um spec que monte uma tela com calendário sem estes provedores estaria exercitando en-US
 * enquanto o navegador roda em pt-BR — a diferença entre `01/08` ser 1º de agosto ou 8 de
 * janeiro. Não pode ir para `test-providers.ts`: aquele arquivo não suporta importar Material
 * (ver a nota lá).</p>
 */
export const PROVEDORES_DATA_BR: Provider[] = [
  { provide: LOCALE_ID, useValue: 'pt-BR' },
  { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
  { provide: DateAdapter, useClass: AdaptadorDataBr },
  { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS },
];

/**
 * Dados do locale pt-BR (nomes de mês e de dia da semana). Precisa rodar antes de o `LOCALE_ID`
 * passar a valer, ou o Angular não encontra o locale em tempo de execução.
 */
export function registrarLocalePtBr(): void {
  registerLocaleData(localePt);
}
